/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reject-demand-dialog.vue?vue&type=template&id=a717bee0&scoped=true&"
import script from "./reject-demand-dialog.vue?vue&type=script&lang=js&"
export * from "./reject-demand-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a717bee0",
  null
  
)

export default component.exports